module.exports = __webpack_public_path__ + "static/img/WechatPrompt_1.1e7a2040.png";